import { useAtom } from 'jotai';
import { useCallback, useEffect } from 'react';
import { useRouter } from 'next/router';
import { cartIsOpenAtom } from '../atoms';

export const useCart = () => {
  const router = useRouter();
  const [isOpen, setIsOpen] = useAtom(cartIsOpenAtom);

  const open = useCallback(() => setIsOpen(true), [setIsOpen]);

  const close = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  useEffect(() => {
    const handleRouteChange = () => {
      setIsOpen(false);
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router, setIsOpen]);

  return {
    isOpen,
    open,
    close
  };
};
